"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerComponent = ContainerComponent;
const React = __importStar(require("react"));
const property_1 = require("@genesys/property");
const GenesysPropertiesSelector = __importStar(require("@genesys/client-core/lib/genesys-properties-selector"));
const ResultComponent = __importStar(require("@genesys/client-core/lib/result-component"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const Actions = __importStar(require("./actions"));
function ContainerComponent(props) {
    const temperature = property_1.PropertyValueSet.getAmount("temperature", props.humidityInput);
    const pressure = property_1.PropertyValueSet.getAmount("pressure", props.humidityInput);
    const humidityInputDef = humidityInputDefinition(temperature, pressure);
    const humidityOutputDef = humidityOutputDefinition(temperature, pressure);
    const onInputChange = (pvs) => props.dispatch(Actions.setPropertiesInput(pvs));
    return (React.createElement(Elements.FlexContainerRowWithPadding, { center: false },
        React.createElement(Elements.InnerContainer, null,
            React.createElement(Elements.H3, null, "Input"),
            React.createElement(GenesysPropertiesSelector.PropertiesSelectorContainer, { selectedProperties: props.humidityInput, productProperties: humidityInputDef, screenAmountProfileFieldGroup: "HumidityConversionInput", onChange: (pvs) => {
                    onInputChange(pvs);
                }, uniqueId: "humidityconversion_input", readOnlyProperties: ["density"] })),
        React.createElement(Elements.InnerContainer, null,
            React.createElement(Elements.H3, null, "Output"),
            React.createElement(ResultComponent.Container, { showLabels: false, propertyDefinitions: humidityOutputDef.map(def => ({
                    sortNo: def.sort_no,
                    propertyName: def.name,
                    conversionParameters: def.conversionParameters
                })), fieldGroup: "HumidityConversionOutput", properties: props.humidityOutput }))));
}
function humidityInputDefinition(temperature, pressure) {
    return [
        {
            sort_no: 1,
            name: "pressure",
            group: "",
            quantity: "Pressure",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 2,
            name: "temperature",
            group: "",
            quantity: "Temperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 3,
            name: "humidity",
            group: "",
            quantity: "HumidityRatio",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            conversionParameters: {
                temperature: temperature,
                pressure: pressure
            },
            value: []
        },
        {
            sort_no: 4,
            name: "density",
            group: "",
            quantity: "Density",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        }
    ];
}
function humidityOutputDefinition(temperature, pressure) {
    return [
        {
            sort_no: 1,
            name: "humidity1",
            group: "",
            quantity: "HumidityRatio",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            conversionParameters: {
                temperature: temperature,
                pressure: pressure
            },
            value: []
        },
        {
            sort_no: 2,
            name: "humidity2",
            group: "",
            quantity: "HumidityRatio",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            conversionParameters: {
                temperature: temperature,
                pressure: pressure
            },
            value: []
        },
        {
            sort_no: 3,
            name: "humidity3",
            group: "",
            quantity: "HumidityRatio",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            conversionParameters: {
                temperature: temperature,
                pressure: pressure
            },
            value: []
        },
        {
            sort_no: 4,
            name: "humidity4",
            group: "",
            quantity: "HumidityRatio",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            conversionParameters: {
                temperature: temperature,
                pressure: pressure
            },
            value: []
        },
        {
            sort_no: 5,
            name: "humidity5",
            group: "",
            quantity: "HumidityRatio",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            conversionParameters: {
                temperature: temperature,
                pressure: pressure
            },
            value: []
        }
    ];
}
//# sourceMappingURL=container-component.js.map